module.exports = __webpack_public_path__ + "static/black-belt-group-7ad5e97975aeacf02c26fa3cb22e5e6b.jpg";